const isChineseEnv =
  process.env.REACT_APP_MANAGEMENT_APP_URL === 'https://admin-preprod.genesysonline.cn' || window._env_.REACT_APP_MANAGEMENT_APP_URL === 'https://admin-preprod.genesysonline.cn';

 export default isChineseEnv;
